<div class="form-container">
  <form [formGroup]="form">
    <div class="form-parent-container" *ngIf="!separateByGroups; else separatedByGroupsTemplate">
      <div *ngFor="let control of controls" class="form-controls">
        <df-control
          (onClickEventRaised)="onClickEvent()"
          (onDropdownChangeRaised)="onDropdownChange($event)"
          (onOverrideActionExecuted)="onOverrideActionExecutedRaised($event)"
          *ngIf="control.visible"
          [control]="control"
          [form]="form"
        ></df-control>
      </div>
    </div>

    <ng-template #separatedByGroupsTemplate>
      <div *ngIf="!separateGroupsByAccordion; else separateGroupsAccordion">
        <div *ngFor="let groupName of groupNames" class="card add-side">
          <div class="card-body">
            <hb-text-subtitle class="text-left" [text]="groupName"></hb-text-subtitle>
            <div *ngFor="let control of controls" class="form-controls">
              <df-control
                (onClickEventRaised)="onClickEvent()"
                (onDropdownChangeRaised)="onDropdownChange($event)"
                *ngIf="control.visible && control.groupName === groupName"
                [control]="control"
                [form]="form"
              ></df-control>
            </div>
          </div>
        </div>
      </div>
    <ng-template #separateGroupsAccordion>
      <p-accordion  [multiple]="true"  [activeIndex]="activeIndex">
        <div *ngFor="let groupName of groupNames" class="card add-side">
          <p-accordionTab header="{{groupName}}">
          <div class="card-body">
            <div *ngFor="let control of controls" class="form-controls">


              <df-control
                (onClickEventRaised)="onClickEvent()"
                (onDropdownChangeRaised)="onDropdownChange($event)"
                *ngIf="control.visible && control.groupName === groupName"
                [control]="control"
                [form]="form"
              ></df-control>
            </div>
          </div>
        </p-accordionTab>
        </div>
      </p-accordion>

    </ng-template>


    </ng-template>
  </form>
</div>
